import { UserAccountType } from "../accounts/IUserAccountType";

/**
 * User types that outrank company-scoped RBAC entirely (PRD: RBAC V1).
 *
 * Partner (Whitelabel/WhitelabelAdmin) and Internal (puzzl_internal/
 * puzzl_internal_guest) accounts must never be denied by the per-user-type
 * permission map — partners admin many companies on behalf of a whitelabel
 * and Internal Zealots support every customer. Without this short-circuit,
 * any route that requires `Execute` (e.g. running payroll) returns 403 for
 * these users because the legacy maps grant `AllCrudActions` only.
 *
 * Single source of truth shared across:
 *  - `@zeal/federation-sdk` `hasRequiredPermissions` (server JWT auth gate)
 *  - `@zeal/sisko` `useIsPrivilegedSession` / `useCan` (browser bypass)
 *  - chakotay `Nav.tsx` (sidebar RBAC item filter)
 *
 * Only applies to JWT-authenticated sessions; API-key auth is checked
 * against `apiKeyPermissions` upstream and is unaffected.
 */
export const PRIVILEGED_USER_TYPES: ReadonlySet<string> = new Set<string>([
  UserAccountType.Whitelabel,
  UserAccountType.WhitelabelAdmin,
  UserAccountType.Internal,
  UserAccountType.InternalGuest,
]);
